import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, WebScrollView, Card, Divider } from '@redlink/components/atoms';
import { ViewBlock } from './viewBlock';
import { LinkBlock } from './linkBlock';
import { VisitorBlock } from './visitorBlock';
import { useQuery, getPageProfileQuery } from '@redlink/services';

export const ReportPage = memo(({ navigation }) => {
  const { styles } = useStyle();

  const {
    data: { PageProfile: { currentPlan } = {} },
  } = useQuery(getPageProfileQuery);

  return (
    <View style={styles.container}>
      <WebScrollView>
        <Card>
          <ViewBlock isProUser={currentPlan.isProUser} />
          <Divider margin={16} />
          <VisitorBlock />
        </Card>
        <Space size={8} />
        <LinkBlock isProUser={currentPlan.isProUser} />
      </WebScrollView>
    </View>
  );
});

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
  },
}));
